import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
} from "@mui/material";
import { Typography } from "@mui/material";
import clsx from "clsx";
import preventDoubleTrad from "../../../../helpers/prevent-double-trad";
import TranslationsEditor from "../../../../components/translationsEditor/TranslationsEditor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PREFIX = "DescriptionApp";

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  divider: `${PREFIX}-divider`,
  accordionColor: `${PREFIX}-accordionColor`,
  accordionDetails: `${PREFIX}-accordionDetails`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: "100%",
    textAlign: "center",
    paddingTop: "1rem",
  },

  [`& .${classes.paddingRoot}`]: {
    padding: "1rem",
  },

  [`& .${classes.title}`]: {
    marginBottom: "0.5rem !important",
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: "1.5rem !important",
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up("sm")]: {
      width: "80%",
      "& > div:first-child": {
        width: "100%",
      },
    },
    margin: "0 auto",
  },

  [`& .${classes.buttonContainer}`]: {
    display: "flex",
    justifyContent: "end",
    marginTop: "1rem",
    [theme.breakpoints.up("sm")]: {
      width: "90%",
    },
  },

  [`& .${classes.actionButton}`]: {
    float: "right",
  },

  [`& .${classes.divider}`]: {},

  [`& .${classes.accordionColor}`]: {
    backgroundColor: "#363636",
    backgroundImage: "none",
    [theme.breakpoints.up("md")]: {
      width: "350px",
    },
  },

  [`& .${classes.accordionDetails}`]: {
    width: "100%",

    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
}));

const DescriptionApp = (props) => {
  const { t } = useTranslation();

  const handleDeleteTranslation = (transIndex) => {
    let tmp = { ...props.exparience };
    const tmp2 = [...tmp.description.translations];
    tmp2.splice(transIndex, 1);
    tmp.description = {
      ...tmp.description,
      translations: tmp2,
    };
    props.setExparience(tmp);
  };

  const handleModifyTranslation = (value, key, transIndex) => {
    let tmp = { ...props.exparience };
    const tmp2 = [...tmp.description.translations];
    tmp2[transIndex] = { ...tmp2[transIndex], [key]: value };
    tmp.description = {
      ...tmp.description,
      translations: tmp2,
    };
    props.setExparience(tmp);
  };

  const handleAddTranslation = (value, key) => {
    let tmp = { ...props.exparience };
    if (key === "translations") {
      const myObj = [...tmp.description[key]];
      const langsArray = preventDoubleTrad(myObj, value);
      tmp["description"] = { ...tmp.description, [key]: langsArray };
    } else {
      tmp[key] = { ...tmp[key], initial: value };
    }
    props.setExparience(tmp);
  };

  const handleMoveTraduction = (fromIndex, toIndex) => {
    if (
      toIndex >= 0 &&
      toIndex < props.exparience.description.translations.length
    ) {
      let tmp = { ...props.exparience };
      const myObj = [...tmp.description.translations];
      const tmpElem = myObj[fromIndex];
      myObj.splice(fromIndex, 1);
      myObj.splice(toIndex, 0, tmpElem);
      tmp = {
        ...tmp,
        description: { ...tmp.description, translations: myObj },
      };
      props.setExparience(tmp);
    }
  };

  if (props.currentStep >= 2) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>
            {t("exparienceCreateForm.appDescriptionTitle")}
          </Typography>
          <Typography variant="body2" className={classes.subTitle}>
            {t("exparienceCreateForm.appDescriptionsubTitle")}
          </Typography>
          <div className={classes.contentContainer}>
            {/* <TextField
                name="descriptionApp"
                label={t('myExpariences.form.descriptionMobileApp')}
                className={clsx(width > 1024 ? classes.maxInputSize : "")}
                onChange={e => props.handleChangeField('descriptionApp', e.target.value)}
                value={props.exparience.descriptionApp}
                fullWidth
                multiline
                variant={"outlined"}
              /> */}
            <Accordion className={classes.accordionColor}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>
                  {t("myExpariences.form.addDescription")}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ textAlign: "left" }}>
                <TranslationsEditor
                  elements={props.exparience.description.translations}
                  defaultText={props.exparience.description.initial}
                  defaultTextKey="description"
                  handleDefaultText={handleAddTranslation}
                  addTranslation={handleAddTranslation}
                  removeTranslation={handleDeleteTranslation}
                  handleTranslation={handleModifyTranslation}
                  configurator
                  translate
                  displayButtonVerticaly
                  moveTraduction={handleMoveTraduction}
                  isCreate
                />
              </AccordionDetails>
            </Accordion>
          </div>
          {props.currentStep === 2 && (
            <div className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={(e) => props.handleNextStep(3)}
                className={classes.actionButton}
              >
                {props.exparience.description.initial.length === 0
                  ? t("exparienceCreateForm.ignoreButton")
                  : t("exparienceCreateForm.continueButton")}
              </Button>
            </div>
          )}
        </div>
        <Divider light className={classes.divider} />
      </Root>
    );
  } else {
    return null;
  }
};

export default DescriptionApp;
